import Image from "next/image";
import Link from "next/link";

type LogoProps = {
  compact?: boolean;
  href?: string;
  tagline?: string;
};

export default function Logo({
  compact = false,
  href = "/",
  tagline,
}: LogoProps) {
  return (
    <Link
      href={href}
      aria-label="Fornecedor.net - Página inicial"
      className={`flex shrink-0 items-center ${compact ? "gap-2.5" : "gap-3"}`}
    >
      <Image
        src="/images/logo-icon-fornecedor.png"
        alt=""
        width={78}
        height={78}
        priority
        className={`w-auto object-contain ${
          compact
            ? "h-[40px] sm:h-[44px]"
            : "h-[48px] sm:h-[58px]"
        }`}
      />

      <span className="flex flex-col font-[Outfit,sans-serif]">
        <span style={tagline ? { letterSpacing: "normal" } : undefined} className={`whitespace-nowrap font-black leading-none tracking-[-0.035em] text-[#0b1b31] ${
          compact
            ? "text-[19px]"
            : "text-[22px]"
        }`}>
          FORNECEDOR
          <span
            className={
              compact
                ? "text-base text-[#2563eb]"
                : "text-lg text-[#2563eb]"
            }
          >
            {" "}.NET
          </span>
        </span>

        <span style={tagline ? { letterSpacing: "normal" } : undefined} className={`${tagline ? "mt-[3px]" : "mt-1"} whitespace-nowrap uppercase ${tagline
          ? "text-[8px] font-medium leading-[1.3] text-slate-600 sm:text-[9px]"
          : `font-medium tracking-[0.12em] text-slate-400 ${compact ? "text-[8px]" : "text-[9px]"}`
        }`}>
          {tagline ?? "Conectando empresas e negócios"}
        </span>
      </span>
    </Link>
  );
}
